import { components } from "@/__openapi__/backend/schema";
import { Uuid } from "@/domains/global/identifiers";
import { ApiSchema } from "@/modules/api";
import {
  UpsertedSyncUpdateResponse,
  DeletedSyncUpdateResponse,
  SyncUpdateValue,
} from "@/store/sync/types";
import { SessionIndexData } from "./SessionIndexes";

/**
 * ============================
 *   Session
 * ============================
 */
export type SessionModelData = ApiSchema["SessionSyncModelDataResponseSchema"];

export type SessionUpsertedSyncUpdateValue = ApiSchema["SessionSyncModelResponseSchema"];
export type SessionDeletedSyncUpdateValue = ApiSchema["SyncUpdatePartialValueResponseSchema"];
export type SessionSyncUpdateValue = SessionUpsertedSyncUpdateValue | SessionDeletedSyncUpdateValue;

export type IndexedSessionSyncUpdateValue = SyncUpdateValue<SessionModelData> & SessionIndexData;

export type SessionUpsertedSyncUpdate = UpsertedSyncUpdateResponse & {
  kind: "UPSERTED";
  value: SessionUpsertedSyncUpdateValue;
};
export type SessionDeletedSyncUpdate = DeletedSyncUpdateResponse & {
  kind: "DELETED";
  value: SessionDeletedSyncUpdateValue;
};
export type SessionSyncUpdate = SessionUpsertedSyncUpdate | SessionDeletedSyncUpdate;

export type SessionStatus = ApiSchema["SessionStatus"];
export type SessionKind = ApiSchema["SessionKind"];

/**
 * ============================
 *   Session Events
 * ============================
 */
export type SessionEventModelData = ApiSchema["SessionEventSyncModelDataResponseSchema"] & {
  feedback_given?: "UPVOTE" | "DOWNVOTE" | null;
};

export type SessionEventUpsertedSyncUpdateValue = ApiSchema["SessionEventSyncModelResponseSchema"];
export type SessionEventDeletedSyncUpdateValue = ApiSchema["SyncUpdatePartialValueResponseSchema"];
export type SessionEventSyncUpdateValue =
  | SessionEventUpsertedSyncUpdateValue
  | SessionEventDeletedSyncUpdateValue;

export type SessionEventUpsertedSyncUpdate = UpsertedSyncUpdateResponse & {
  kind: "UPSERTED";
  value: SessionEventUpsertedSyncUpdateValue;
};
export type SessionEventDeletedSyncUpdate = DeletedSyncUpdateResponse & {
  kind: "DELETED";
  value: SessionEventDeletedSyncUpdateValue;
};
export type SessionEventSyncUpdate = SessionEventUpsertedSyncUpdate | SessionEventDeletedSyncUpdate;

export type SessionEventKind = ApiSchema["EventKindF80Enum"];

export type SessionMessageEventKind =
  | "REASONING"
  | "ACTION"
  | "COMMUNICATION"
  | "INPUT_REQUEST"
  | "INPUT_RESPONSE";

export type SessionMessageInputRequestForm = "IMPORT_MARKDOWN";

/**
 * Other Types
 */

export type SessionRecord = { id: Uuid };

export type SessionEventRecord = { id: Uuid };
export type SessionEvent = components["schemas"]["SessionEventSummaryResponseSchema"];
export type SessionConfig = components["schemas"]["SessionConfigValueV1Schema"];

export type SessionPreviousChatsIndexTuple = [
  kind: SessionKind,
  lastUserActionAt: string,
  title: string,
  modelId: string,
];

export type SessionIndexTuple = [
  kind: SessionKind,
  status: SessionStatus,
  created_at: string,
  modelId: string,
];

export type SessionPreviousChats = {
  kind: SessionKind;
  lastUserActionAt: string;
  title: string;
  modelId: string;
};

export type SessionConfigVariant = components["schemas"]["SessionConfigVariant"];

// Re-exported from @/domains/chat-model for backwards compatibility
export { ChatModel } from "@/domains/chat-model";

export const SESSION_DEFAULT_VARIANT: SessionConfigVariant = "STANDARD";
